enum UserLabel {
    Favorite = 'FAVORITE',
    Response = 'RESPONSE',
    Invite = 'INVITE',
    Discard = 'DISCARD',
    Question = 'QUESTION',
}

export { UserLabel };
